import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { Search } from 'lucide-react'

export default function SearchIcon(props) {
    const { contextStyles, className, size = 16 } = props

    return (
        <div className={cn(styles.iconComp, contextStyles, className)}>
            <Search size={size} />
        </div>
    )
}
